export default "__VITE_ASSET__CXbI7LgH__"